import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  watchListSetProp: ['key', 'value'],
  watchListReset: null,
})

export const WatchListTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  sortBy: 'most_recent',
  createdDate: [],
  seenDate: [],

  page_column_size: 3,
  subPage: 'Following',
})

/* ------------- Selectors ------------- */
export const getState = state => state.watchList

export const watchListSetProp = (state, {key, value}) => {
  return state.set(key, value)
}

export const watchListReset = state => {
  return state.merge({
    sortBy: 'most_recent',
    createdDate: [],
    seenDate: [],
  })
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.WATCH_LIST_SET_PROP]: watchListSetProp,
  [Types.WATCH_LIST_RESET]: watchListReset,
})
